import { gql } from '@apollo/client';

export const apiRequestParts = gql`
  fragment apiRequest on ApiRequest {
    id
    applied
    description
    status
    client {
      id
      authEndPoint
      status
    }
  }
`;

export const GET_API_REQUESTS = gql`
  query apiRequests {
    apiRequests {
      ...apiRequest
    }
  }
  ${apiRequestParts}
`;
